import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "react-emotion";
import { withRedux } from "helpers";

const LogoStyle = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5rem;
  margin: 20px;
  font-size: ${(props) => (props.fontSize ? props.fontSize : "1.5rem")};
  cursor: pointer;
  transition: 0.3s;
  font-weight: bold;
  margin-left: 2em;

  a {
    text-decoration: none;
    color: ${(props) => (props.color ? props.color : "#FFFFFF")};
    font-family: "Tangerine", cursive;
  }

  &:hover {
    opacity: 1;
    transition: 0.5s;
  }
  @media only screen and (max-width: 500px) {
    margin-left: 1em;
  }
`;

const headerLogoPic = css`
  cursor: pointer;
  @media only screen and (min-width: 300px) and (max-width: 768px) {
    width: 150px;
    height: 40px;
    object-fit: contain;
  }
  @media only screen and (min-width: 768px) {
    width: 190px;
    height: 90px;
    object-fit: contain;
  }
`;

const logoImageStyle = css`
  height: 80px;
`;

const mobileLogo = css`
  display: none;

  /* @media only screen and (max-width: 899px) {
    display: block !important;
    width: 170px;
    height: 40px;
    object-fit: contain;
    margin-left: -37px;
  } */
`;
const responsiveLogo = css`
  width: 250px;
  height: 40px;
  object-fit: contain;
  margin-left: -50px;
  /* @media only screen and (max-width: 899px) {
    display: none;
  } */
`;

const linkStyle = css`
  max-height: 4em;
  width: 100%;

  cursor: pointer;
`;

const Logo = (props) => {
  // console.log(props);
  const onClickHandler = () => {
    props.history.push("/lobby");
  };
  return (
    <Link className={linkStyle} to="/lobby">
      <img
        className={mobileLogo}
        // src="https://mobile360-assets.s3.us-east-2.amazonaws.com/logo/just_logo.png"
        src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/logo_small.png"
        alt="mobileLogo"
      />

      <img
        src="https://mobile360-assets.s3.us-east-2.amazonaws.com/landing/logo_small.png"
        className={responsiveLogo}
        alt="responsiveLogo"
      />
      {/* <button onClick={onClickHandler}></button> */}
    </Link>
  );
};

export default withRedux(Logo);
